import { jsx } from 'react/jsx-runtime';
import { styled, css } from '@hexx/theme';
import { Children } from 'react';
import ReactHtmlParser from 'react-html-parser';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var Wrapper = styled('div', {
  position: 'relative',
  WebkitBoxSizing: 'border-box',
  boxSizing: 'border-box',
  zIndex: 1,
  'div:first-of-type': {
    marginTop: 0
  },
  h1: {
    fontSize: '2.5rem',
    fontWeight: 700
  },
  h2: {
    fontSize: '2rem',
    fontWeight: 700
  },
  h3: {
    fontSize: '1.5rem',
    fontWeight: 700
  },
  h4: {
    fontSize: '1.25rem',
    fontWeight: 700
  },
  h5: {
    fontSize: '1rem',
    fontWeight: 700
  },
  h6: {
    fontSize: '0.875rem',
    fontWeight: 700
  }
});
var BlockWrapper = styled('div', {
  position: 'relative',
  paddingTop: 16,
  paddingBottom: 16,
  padding: '.4em 0',
  margin: '0 auto',
  maxWidth: 650
});
function EditorRenderer(_ref) {
  var blocks = _ref.blocks,
      blockMap = _ref.blockMap,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? '720px' : _ref$maxWidth,
      blockWrapper = _ref.blockWrapper,
      wrapper = _ref.wrapper;

  if (!Array.isArray(blocks)) {
    return null;
  }

  var content = Children.toArray(blocks.map(function (block) {
    var Renderer = blockMap[block === null || block === void 0 ? void 0 : block.type];

    if (!Renderer) {
      return null;
    }

    if (_typeof(block.data) !== 'object') {
      return null;
    }

    var hasStretched = 'stretched' in block.data && !!block.data.stretched;
    return /*#__PURE__*/jsx(BlockWrapper, _objectSpread2(_objectSpread2({
      style: {
        maxWidth: hasStretched ? 'none' : maxWidth
      }
    }, blockWrapper), {}, {
      children: /*#__PURE__*/jsx(Renderer, {
        data: block.data
      })
    }));
  }));
  return /*#__PURE__*/jsx(Wrapper, _objectSpread2(_objectSpread2({}, wrapper), {}, {
    children: content
  }));
}

var dividerStyles = {
  lineHeight: '1.6em',
  width: '100%',
  height: 'auto',
  textAlign: 'center',
  margin: 'unset',
  borderStyle: 'none',
  '::before': {
    display: 'inline-block',
    color: '#C4C4C4',
    content: "'\u30FB\u30FB\u30FB'",
    fontSize: '30px',
    lineHeight: '38px',
    letterSpacing: '0.2em'
  }
};
var DelimiterRenderer = function DelimiterRenderer() {
  return /*#__PURE__*/jsx("hr", {
    role: "separator",
    className: css(dividerStyles)
  });
};

var headerStyle = {
  padding: '1em 0',
  lineHeight: '1.5em',
  outline: 'none',
  variants: {
    h: {
      1: {
        fontSize: '40px',
        lineHeight: '40px',
        fontWeight: 'bold'
      },
      2: {
        fontSize: '32px',
        fontWeight: 'bold',
        lineHeight: '38px'
      },
      3: {
        fontSize: '24px',
        lineHeight: '32px',
        fontWeight: 'bold'
      },
      4: {
        fontSize: '20px',
        lineHeight: '24px',
        fontWeight: 'bold'
      },
      5: {
        fontSize: '16px',
        lineHeight: '20px',
        fontWeight: 'bold'
      },
      6: {
        fontSize: '14px',
        lineHeight: '18px',
        fontWeight: 'bold'
      }
    }
  }
};
var Heading = styled('h3', headerStyle);
var HeaderRenderer = function HeaderRenderer(_ref) {
  var data = _ref.data;
  var level = data.level || 3;
  return /*#__PURE__*/jsx(Heading, {
    as: "h".concat(level),
    h: level,
    children: ReactHtmlParser(data.text)
  });
};

var commonListStyle = {
  paddingLeft: 40,
  outline: 'none',
  position: 'relative',
  left: 18
};
var listStyle = {
  ul: _objectSpread2({
    listStyle: 'disc'
  }, commonListStyle),
  ol: _objectSpread2({
    listStyle: 'decimal'
  }, commonListStyle),
  item: {
    padding: '5.5px 0 5.5px 3px',
    lineHeight: '1.6em'
  }
};
var ListRenderer = function ListRenderer(_ref) {
  var data = _ref.data;
  var listItems = Children.toArray(data.items.map(function (item) {
    return /*#__PURE__*/jsx("li", {
      className: css(listStyle.item),
      children: ReactHtmlParser(item)
    });
  }));

  if (data.style === 'ordered') {
    return /*#__PURE__*/jsx("ol", {
      className: css(listStyle.ol),
      children: listItems
    });
  }

  if (data.style === 'unordered') {
    return /*#__PURE__*/jsx("ul", {
      className: css(listStyle.ul),
      children: listItems
    });
  }

  return null;
};

var paragraphStyle = {
  p: {
    lineHeight: '24px',
    fontSize: '16px',
    outline: 'none',
    mark: {
      background: 'rgba(228, 178, 2, 0.18)',
      padding: '3px 0'
    },
    a: {
      cursor: 'pointer',
      textDecoration: 'underline'
    }
  }
};
var ParagraphRenderer = function ParagraphRenderer(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/jsx("p", {
    className: css(paragraphStyle),
    style: {
      textAlign: data.alignment || 'left'
    },
    children: ReactHtmlParser(data.text)
  });
};

var quoteStyle = {
  wrapper: {
    paddingLeft: '24px',
    paddingRight: '24px',
    paddingTop: 3,
    paddingBottom: 3
  },
  text: {
    borderTop: 'none',
    borderRight: 'none',
    borderBottom: 'none',
    borderImage: 'initial',
    borderLeft: '2px solid rgb(36, 37, 38)',
    boxShadow: 'none',
    borderRadius: 0,
    marginTop: 8,
    marginBottom: 8,
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 16,
    paddingRight: 12,
    fontSize: '1rem',
    lineHeight: '20px',
    fontStyle: 'italic',
    color: 'rgb(36, 37, 38)',
    minHeight: 'unset !important'
  }
};
var QuoteRenderer = function QuoteRenderer(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/jsx("blockquote", {
    className: css(quoteStyle.wrapper),
    children: /*#__PURE__*/jsx("div", {
      className: css(quoteStyle.text),
      children: ReactHtmlParser(data.text)
    })
  });
};

var BlockMap = {
  paragraph: ParagraphRenderer,
  delimiter: DelimiterRenderer,
  header: HeaderRenderer,
  list: ListRenderer,
  quote: QuoteRenderer
};

export { BlockMap, DelimiterRenderer, EditorRenderer, HeaderRenderer, ListRenderer, ParagraphRenderer, QuoteRenderer, dividerStyles, headerStyle, listStyle, paragraphStyle, quoteStyle };
